import { useEffect, useState } from 'react'
import { useAuthStore } from 'src/store/auth'

import './Home.css'

export const Home = () => {
  const { setActiveKeyMainMenu } = useAuthStore((store) => store)

  useEffect(() => {
    setActiveKeyMainMenu('')
  }, [setActiveKeyMainMenu])

  return (
    <div>
      <h1>HOME</h1>
    </div>
  )
}
